/**
 * =============================================================================
 * SCRIPT-NAME:   AdminDashboard.js
 * PROJEKT:       Freiseinapp - Admin-Zentrale
 * VERSION:       v1.i26
 * DATUM:         2026-03-03
 * AENDERUNGEN v1.i26:
 * - Link /ads-manager entfernt (AdsAssetManager ersetzt durch API-Sync)
 * =============================================================================
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import BackButton from "./BackButton";
import "./AdminDashboard.css";

export default function AdminDashboard() {
    const logo = "/logo192.png";
    const [currentDateTime, setCurrentDateTime] = useState(new Date());

    useEffect(() => {
        const timerId = setInterval(() => {
            setCurrentDateTime(new Date());
        }, 1000);
        return () => clearInterval(timerId);
    }, []);

    const formattedDateTime = currentDateTime.toLocaleString('de-DE', {
        weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
    });

    return (
        <div className="dashboard-page-wrapper">
            <div className="dashboard-content-box">

                <header className="dashboard-header">
                    <div className="dashboard-header-left">
                        <img src={logo} alt="FreiSeinApp Logo" className="dashboard-logo" />
                        <div className="dashboard-header-info">
                            <p className="dashboard-welcome">Willkommen im Adminbereich!</p>
                            <p className="dashboard-current-datetime">Aktuell: {formattedDateTime}</p>
                        </div>
                    </div>
                    <h2 className="dashboard-title">👨‍💼 Admin Dashboard</h2>
                </header>

                <nav className="dashboard-nav">
                    <ul>
                        <li><Link to="/contacts">📇 Kontakte & GADS Upload</Link></li>
                        <li><Link to="/admin-freischaltung">🔓 Freischaltungen</Link></li>
                        <li><Link to="/analytics">📊 Landingpage Analyse</Link></li>
                        <li><Link to="/ads-perf" className="nav-highlight">📈 Ads Performance</Link></li>
                        <li><Link to="/gads-kpi" className="nav-highlight">📊 GADS KPI</Link></li>
                        <li><Link to="/prognose-tracker" className="nav-highlight">🎯 Prognose-Tracker</Link></li>
                        <li><Link to="/redaktionsplan" className="nav-highlight">📋 Redaktionsplan</Link></li>
                        <li><Link to="/ads-keywords" className="nav-highlight">🔑 Ads Keyword Manager</Link></li>
                        <li><Link to="/kdi-tracker">📈 KDI-Wettbewerbsanalyse</Link></li>
                        <li><Link to="/gsc-kpi" className="nav-highlight">📊 GSC KPI-Dashboard</Link></li>
                        <li><Link to="/gsc-status" className="nav-highlight">🔎 GSC Seiten-Status</Link></li>
                        <li><Link to="/send-email">✉️ E-Mail senden</Link></li>
                        <li><Link to="/speed-test">🚀 Geschwindigkeitstest</Link></li>
                        <hr className="nav-divider" />
                        <li><a href="/api/selbst_admin_prompts.php">🤖 KI-Prompts (Selbstkonzept)</a></li>
                        <li><a href="/api/webinar_admin_prompts.php">🤖 KI-Prompts (Webinar)</a></li>
                        <li><a href="/api/bza_lp_admin_prompts.php">🤖 KI-Prompts (Landing-Page)</a></li>
                    </ul>
                </nav>

                <div className="dashboard-footer">
                    <BackButton />
                </div>
            </div>
        </div>
    );
}